:host {
  --x-transform: 0;
  --y-transform: 0;
  .modal-container {
    width: 100%;
    height: 100%;
    background: #00000033;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 100000;
  }

  .modal-close {
    cursor: pointer;

    &:focus {
      outline: 1px solid var(--hcl-color-outline);
      border-radius: 2px;
    }
  }

  .modal-class {
    padding: 17px;
    display: grid;
    background-color: var(--hcl-color-view_bkg);

    position: absolute;
    grid-template-rows: auto 1fr;
    grid-gap: 10px;

    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 100001;
  }

  .modal-title {
    display: grid;
    grid-template-columns: 1fr auto;
    justify-content: center;
    align-items: center;

    .title {
      color: var(--hcl-color-primary);
      @include applyFontStyle("modal_title");
    }
  }

  .size-mobile {
    .modal-content {
      display: flex;
    }
  }

  .size-tablet,
  .size-desktop {
    
    .modal-class {
      --x-transform: -50%;
      --y-transform: -50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(var(--x-transform), var(--y-transform));
      padding: 14px 17px 17px 17px;
      background-color: var(--hcl-color-header_block);
      width: auto;
      height: auto;
      border: 1px solid var(--hcl-color-card_border);
      min-width: 338px;
      border-radius: 5px;

      &.top-20 {
        top: 20%;
        --y-transform: -20%;
      }
    }
  }

  .size-mobile, .size-tablet, .size-desktop {
    .border-rounded-10 {
      border-radius: 10px;
      border: solid 1px #1a1a1b;
    }
    .modal-title {
      text-align: left;
      position: relative;
      
      .icon {
        top: 0;
        right: 0;
        position: absolute;
      }
    }
  }

  .size-mobile {
    .modal-mobile-center {
      --x-transform: -50%;
      --y-transform: -50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(var(--x-transform), var(--y-transform));
      padding: 14px 17px 17px 17px;
      background-color: var(--hcl-color-header_block);
      width: auto;
      height: auto;
      border: 1px solid var(--hcl-color-card_border);
      min-width: 338px;
      border-radius: 5px;
    }
  }
  
}